// ═══════════════════════════════════════════════════════════════════
//  modules/dashboard/constantes.js
//  JOURS_LMS · SRV
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

// ═══════════════════════════════════════════════════════════════════════
//  MODULE DASHBOARD — page d'accueil (spéc v1.3)
//  À COLLER dans App.js juste AVANT  `function Dashboard(...)`.
//  Dépend de THEME, BouxImg, API_BASE (déjà dans App.js). Aucune lib externe.
// ═══════════════════════════════════════════════════════════════════════
export const JOURS_LMS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

export const SRV = {
  en_ligne: { t: "EN LIGNE", c: THEME.emerald, b: THEME.emeraldDim },
  hors_ligne: { t: "HORS LIGNE", c: THEME.red, b: THEME.redDim },
  partiel: { t: "PARTIEL", c: THEME.amber, b: THEME.amberDim },
};
